import React from 'react'
import '../card/Card.css'

export const SpecialProduct = (props) => {
  return (
    <div className='three-grid__cont'>{props.children}</div>
  )
}

